/**
 =========================================================
 * Material Dashboard 2 React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import { forwardRef } from 'react'

// prop-types is a library for typechecking of props
import PropTypes from 'prop-types'

// Custom styles for MDInput
import MDInputRoot from './MDInputRoot'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import IconButton from '@mui/material/IconButton'
import useMdInput from '../../../hooks/useMdInput'
import { LuRefreshCcw } from 'react-icons/lu'

const MDInput = forwardRef(
  (
    {
      error,
      success,
      disabled,
      showPassword,
      suggestPassword,
      handleGeneratePassword,
      ...rest
    },
    ref,
  ) => {
    const { passwordVisible, togglePasswordVisibility } = useMdInput()
    return (
      <>
        <div className="relative inline-block w-full">
          <MDInputRoot
            {...rest}
            ref={ref}
            type={
              showPassword ? (passwordVisible ? 'text' : 'password') : rest.type
            }
            ownerState={{ error, success, disabled }}
            className="w-full "
          />
          <div
            className={`absolute top-[5%] ${
              error
                ? 'right-[11%] xs:right-[8%] md:right-[10%] lg:right-[8%] xlg:right-[6%]'
                : 'right-0'
            }`}
          >
            <div className={`flex flex-row-reverse ${error ?? 'mr-[15px]'}`}>
              {showPassword ? (
                <div>
                  <IconButton onClick={togglePasswordVisibility}>
                    {passwordVisible ? (
                      <VisibilityOff className="text-over-secondary-background" />
                    ) : (
                      <Visibility className="text-over-secondary-background" />
                    )}
                  </IconButton>
                </div>
              ) : null}
              {suggestPassword ? (
                <div className="mr-[-5px]">
                  <IconButton onClick={handleGeneratePassword}>
                    <LuRefreshCcw className="text-over-secondary-background" />
                  </IconButton>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </>
    )
  },
)

// Setting default values for the props of MDInput
MDInput.defaultProps = {
  error: false,
  success: false,
  disabled: false,
  showPassword: false,
  suggestPassword: false,
}

// Typechecking props for the MDInput
MDInput.propTypes = {
  error: PropTypes.bool,
  success: PropTypes.bool,
  disabled: PropTypes.bool,
  showPassword: PropTypes.bool,
  suggestPassword: PropTypes.bool,
}

export default MDInput
